import React from 'react';
import Geosuggest from 'react-geosuggest';
import './geosuggest.scss';
import './searchbox.scss';
import DataBox from '../DataBox';

class SearchBox extends React.Component {
  state ={
    placeData: []
  }
  onSuggestSelect = (placeData) => {
    if(placeData)
      this.setState({
        placeData
      })
  }
  render() {
    return (
      <div className="box-item">
        <div className="placebox">
          <Geosuggest 
            placeholder={this.props.placeholder}
            onSuggestSelect={this.onSuggestSelect}
            placeDetailFields={['rating', 'reviews', 'user_ratings_total', 'address_components', 'international_phone_number', 'name', 'opening_hours']}
          />
        </div>
        <DataBox placeData={this.state.placeData}/>
      </div>
    )
  }
}

export default SearchBox;